import { Popover, Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder, apis, conf, inWindow, } from 'api';
import { navigate } from 'gatsby';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { transAvatarSize } from '@web-common/utils/contact_util';
import styles from './avatar.module.scss';
import { ReactComponent as ExitSvg } from '@/images/icons/exit_icon.svg';
import { ReactComponent as ExpandSvg } from '@/images/icons/arrow-expand.svg';
import RightArrowIcon from '@/images/icons/arrow-right-1.svg';
import ExitIcon from '@/images/icons/exit.svg';
import About from '@/components/Electron/About';
import ProductVersion from '@/components/Electron/ProductVersion';
import Loadable from '@loadable/component';
const FeedbackModal = Loadable(() => import('@/components/Electron/FeedBack/feedbackModal'));
import SiriusMessage from '../Message/SiriusMessage';
import AvatarEditor from '../AvatarEditor/avatarEditor';
import AvatarTag from './avatarTag';
import { actions as hollowOutGuideActions } from '@web-common/state/reducer/hollowOutGuideReducer';
import { getMenuSettingsAsync, getMyRolesAsync } from '@web-common/state/reducer/privilegeReducer';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { feedbackUploadLog } from '@web-common/utils/uploadLog';
import UpgradeMeansModal from '@web-mail/components/UpgradeMeansModal/index';
import SuccessModal from '@web-mail/components/UpgradeMeansModal/successModal';
import { getIsSomeMenuVisbleSelector } from '@web-common/state/reducer/privilegeReducer';
import { getTransText } from '@/components/util/translate';
import { handleBackEnd } from '@web-mail/util';
import { getIn18Text } from 'api';
import lodashGet from 'lodash/get';
import { useOpenHelpCenter } from '@web-common/utils/utils';
import { handleKf, handleKfScriptLoad } from '@web-common/components/LingxiKfEntry';
import useRemoteDebugTools from '@web-common/hooks/useRemoteDebugTools';
import { WAIMAO_PRODUCT_VERSIONS } from '@web-common/conf/waimao/constant';
import { getHelperCenterUrl } from '@web-common/utils/getHelperCenterUrl';
const isEnLang = inWindow() && window.systemLang === 'en';
const systemApi = apiHolder.api.getSystemApi();
const httpApi = apiHolder.api.getDataTransApi();
const loginApi = apiHolder.api.requireLogicalApi(apis.loginApiImpl);
const eventApi = apiHolder.api.getEventApi();
const upgradeAppApi = apiHolder.api.requireLogicalApi(apis.upgradeAppApiImpl);
const inElectron = apiHolder.env.forElectron;
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const jumpToLogin = (retry) => {
    setTimeout(() => {
        const logoutPage = httpApi.getLogoutPage();
        console.warn('jump to logout page ', logoutPage);
        if (systemApi.getCurrentUser() == undefined) {
            window.location.assign(logoutPage);
        }
        else if (retry > 0) {
            jumpToLogin(retry - 1);
        }
        else {
            window.localStorage.clear();
            window.location.assign(logoutPage);
        }
    }, 700);
};
const SubMenuItem = ({ item }) => {
    const onClick = (e) => {
        e.stopPropagation();
        const { callback } = item;
        callback();
    };
    return (React.createElement("div", { className: styles.subMenuItem, onClick: onClick }, item.title));
};
const SubMenu = ({ subItems }) => (React.createElement("div", { className: styles.subMenu }, subItems && subItems.map(item => React.createElement(SubMenuItem, { key: item.id, item: item }))));
const MenuItem = ({ onCLick, title, subItems, type, productName }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);
    const mailSettingRemind = useAppSelector(state => state.hollowOutGuideReducer.avatarRemind.mailSettingRemind.isShow);
    const isMailSettingRemindShow = useMemo(() => {
        return mailSettingRemind && type === 'setting';
    }, [title, mailSettingRemind]);
    const onMouseEnter = () => {
        if (subItems && (subItems === null || subItems === void 0 ? void 0 : subItems.length) > 0) {
            setShowSubMenu(true);
        }
    };
    const onMouseLeave = () => {
        setShowSubMenu(false);
    };
    return (React.createElement("div", { className: styles.contentItemWrap, "data-test-id": type === 'account' ? 'pc_avatar_menu_account_and_security' : '', onClick: onCLick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("div", { className: styles.contentItem },
            React.createElement("i", { className: classnames(styles.itemIcon, styles[type]) }),
            React.createElement("span", { className: styles.itemLink },
                React.createElement("span", null, title),
                type === 'productVersion' && React.createElement("span", { className: styles.itemLinkRight }, productName)),
            React.createElement("span", { className: styles.itemRemind, hidden: !isMailSettingRemindShow }),
            React.createElement("img", { className: styles.itemLinkArrow, src: type === 'backend' ? ExitIcon : RightArrowIcon, alt: "arrow-right" }),
            showSubMenu && React.createElement(SubMenu, { subItems: subItems }))));
};
const AvatarContent = ({ user, toggleVisible, mailList = [], visibleAdmin }) => {
    var _a, _b, _c, _d;
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [showAvatarEditor, setShowAvatarEditor] = useState(false);
    const [curAvatar, setCurAvatar] = useState();
    const [productVisible, setProductVisible] = useState(false);
    const [upGradeVisible, setUpGradeVisible] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);
    const contactId = useMemo(() => { var _a, _b; return ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.contactId) || ''; }, [user]);
    const contactEmail = useMemo(() => (user === null || user === void 0 ? void 0 : user.id) || '', [user]);
    const avatarInputRef = useRef(null);
    const { changeRemind } = hollowOutGuideActions;
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const isEdmAdmin = useAppSelector(state => state.privilegeReducer.roles.some(role => role.roleType === 'ADMIN'));
    const rbacVisible = useAppSelector(state => state.privilegeReducer.visibleMenuLabels['PRIVILEGE'] === true);
    const version = useAppSelector(state => state.privilegeReducer.version);
    const navigateVersion = useAppSelector(state => state.privilegeReducer.navigateVersion);
    const isNovice = useAppSelector(state => state.noviceTaskReducer.isNovice);
    const dispatch = useAppDispatch();
    const openHelpCenter = useOpenHelpCenter();
    const { sharedAccount } = useAppSelector(state => state.loginReducer);
    const qiyuLoading = useRef(false);
    const vipAdmin = false;
    const usageManual = () => {
        const helperUrl = 'https://lingxi.office.163.com/help/';
        systemApi.openNewWindow(helperUrl);
        trackApi.track('pcMineCenter_click_usageManual');
    };
    const helperCenter = () => {
        const helperUrl = getHelperCenterUrl({
            isEnLang,
            isEDM: Boolean(process.env.BUILD_ISEDM),
            productVersionId,
        });
        systemApi.openNewWindow(helperUrl);
        trackApi.track('pcMineCenter_click_helperCenter');
    };
    const uploadLog = () => {
        const hide = message.loading(getIn18Text('RIZHISHANGCHUANZHONG，QING'), 0);
        feedbackUploadLog().then(hide);
    };
    const feedback = async () => {
        if (systemApi.isElectron()) {
            systemApi.createWindow('feedback').then();
        }
        else {
            setShowFeedbackModal(true);
        }
    };
    const [orgConf, setOrgConf] = useState({
        orgId: '',
        corpId: 0,
        corpName: '',
        domain: '',
    });
    const contactService = () => {
        handleKfScriptLoad(qiyuLoading).then(() => {
            handleKf(orgConf);
        });
    };
    const closeFeedback = () => {
        setShowFeedbackModal(false);
    };
    const handleLogout = async () => {
        trackApi.track('pcMineCenter_click_logOut_mineCenterCard');
        await loginApi.doLogout(false, true);
        console.log('------ui will logout------');
        jumpToLogin(3);
    };
    let tgFunc;
    const handle = (toggle) => {
        tgFunc = toggle;
        console.log('clicked about page');
    };
    const handleProduct = (visible) => {
        setProductVisible(visible);
    };
    const onUpgradeModel = async () => {
        handleBackEnd({ anchor: '/valueAdd/versionService', payform: 'lingxioffice' });
    };
    const handleAbout = () => {
        trackApi.track('pcMineCenter_click_aboutApplication_mineCenterCard');
        if (inElectron && window.electronLib) {
            systemApi.createWindow('about').then();
        }
        else {
            tgFunc();
        }
    };
    const checkUpgrade = () => {
        upgradeAppApi.doUpdateCheck({ forcePopup: true });
    };
    const handleClick = (type) => {
        toggleVisible();
        switch (type) {
            case 'logout':
                handleLogout();
                break;
            case 'about':
                handleAbout();
                break;
            case 'mailSetting':
                dispatch(changeRemind('avatarRemind.mailSettingRemind'));
                navigate('/#setting', { state: { currentTab: 'mail' } });
                break;
            case 'accountSetting':
                navigate('/#setting', { state: { currentTab: 'account' } });
                break;
            case 'systemTask':
                trackApi.track('waimao_my_task', { action: 'headpic' });
                navigate('#systemTask?page=systemTask');
                break;
            case 'noviceTask':
                trackApi.track('waimao_newusertask', { action: 'headpic_newusertask' });
                navigate('#noviceTask?page=noviceTask');
                break;
            case 'productVersion':
                trackApi.track('pcMineCenter_version_click');
                handleProduct(true);
                break;
            case 'rbac':
                navigate('/#rbac');
                break;
            case 'backend':
                handleBackEnd();
                break;
            case 'wmWebEntry':
                trackApi.track('waimao_desktop_accessweb', { action: 'visit_the_Web_version' });
                systemApi.openNewWindow('https://waimao.office.163.com/', false);
                break;
            case 'wmOldWebEntry':
                const currentUser = systemApi.getCurrentUser();
                if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) {
                    window.location.replace(`https://waimao.office.163.com/jump/index.html?sid=${currentUser.sessionId}`);
                }
                else {
                    window.location.replace('https://waimao.office.163.com/');
                }
                break;
            case 'wmUpdateLog':
                openHelpCenter('/c/1598628690920579073.html');
                break;
            case 'knowledgeCenter':
                openHelpCenter();
                trackApi.track('waimao_knowledge_square', { action: 'headpic_knowledge_square' });
                break;
            case 'lockApp':
                systemApi.lockApp();
                break;
            default:
                break;
        }
    };
    const aliasPopover = (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: 14 } },
            React.createElement("div", { style: { color: '#A8AAAD', marginBottom: 4 } }, getIn18Text('ZHUZHANGHAO')),
            React.createElement("div", null, user.id)),
        React.createElement("div", null,
            React.createElement("div", { style: { color: '#A8AAAD', marginBottom: 4 } }, getIn18Text('BIEMINGYOUXIANG')), mailList === null || mailList === void 0 ? void 0 :
            mailList.map(alias => (React.createElement("div", { key: alias }, alias))))));
    const checkAvatar = () => {
        var _a;
        if (isCorpMail) {
            return;
        }
        if (showAvatarEditor) {
            setShowAvatarEditor(false);
            return;
        }
        if (!(user === null || user === void 0 ? void 0 : user.avatar)) {
            (_a = avatarInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
        else {
            const bigAvatar = transAvatarSize(user.avatar, 'big');
            console.log('bigAvatar', bigAvatar);
            setCurAvatar(bigAvatar);
            setShowAvatarEditor(true);
        }
    };
    const avatarInputChange = () => {
        var _a;
        const files = (_a = avatarInputRef === null || avatarInputRef === void 0 ? void 0 : avatarInputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && files[0]) {
            const maxSize = 15 * 1024 * 1024;
            if (files[0].size > maxSize) {
                SiriusMessage.warn({ content: getIn18Text('TUPIANDAXIAOBU') });
                return;
            }
            setCurAvatar(files[0]);
            setShowAvatarEditor(true);
        }
    };
    const hideAvatarEditor = () => {
        setShowAvatarEditor(false);
    };
    const { productVersionInfo: { productVersionName, productVersionId }, } = useGetProductAuth();
    const { debugToolsVisible, remoteVisible, handleSnapshotClick, handleRemoteClick } = useRemoteDebugTools();
    const helpSub = [
        ...(!isEnLang
            ? [
                { id: 'usageManual', title: getIn18Text('usageManual'), callback: usageManual },
                { id: 'helperCenter', title: getIn18Text('BANGZHUZHONGXIN'), callback: helperCenter },
            ]
            : [{ id: 'helperCenter', title: getIn18Text('BANGZHUZHONGXIN'), callback: helperCenter }]),
        { id: 'questionApply', title: getIn18Text('WENTIFANKUI'), callback: feedback },
        { id: 'contactServer', title: vipAdmin ? getIn18Text('VIPKEFU') : getIn18Text('LIANXIKEFU'), callback: contactService },
        { id: 'snapshot', title: debugToolsVisible ? getIn18Text('GUANBILUZ') : getIn18Text('LUZHIKUAIZ'), callback: handleSnapshotClick },
        { id: 'remoteDebug', title: remoteVisible ? getIn18Text('TINGZHIXIEZ') : getIn18Text('YUANCHENGXIEZ'), callback: handleRemoteClick },
    ];
    const wbhelpSub = [
        { id: 'uploadLog', title: getIn18Text('SHANGCHUANRIZ'), callback: uploadLog },
        { id: 'snapshot', title: debugToolsVisible ? getIn18Text('GUANBILUZ') : getIn18Text('LUZHIKUAIZ'), callback: handleSnapshotClick },
        { id: 'remoteDebug', title: remoteVisible ? getIn18Text('TINGZHIXIEZ') : getIn18Text('YUANCHENGXIEZ'), callback: handleRemoteClick },
    ];
    const visibleEnterpriseSetting = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['ORG_SETTINGS']));
    const visibleSystemTask = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['TASK_CENTER']));
    const taskCenterSubItems = [
        visibleSystemTask && { id: 'systemTask', title: getTransText('WODERENWU'), callback: () => handleClick('systemTask') },
        {
            id: 'noviceTask',
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", null, getTransText('XINSHOURENWU')),
                isNovice && React.createElement("span", { className: styles.newAccount }, "\u65B0\u7528\u6237"))),
            callback: () => handleClick('noviceTask'),
        },
    ].filter(Boolean);
    if (productVersionId === 'free') {
        const contactServerIdx = helpSub.findIndex(item => (item === null || item === void 0 ? void 0 : item.id) === 'contactServer');
        if (contactServerIdx !== -1) {
            helpSub.splice(contactServerIdx, 1);
        }
        const helpCenterIdx = helpSub.findIndex(item => (item === null || item === void 0 ? void 0 : item.id) === 'helperCenter');
        if (helpCenterIdx !== -1) {
            helpSub.splice(helpCenterIdx, 1);
        }
    }
    else {
        if (!isEnLang) {
            const usageManualIdx = helpSub.findIndex(item => (item === null || item === void 0 ? void 0 : item.id) === 'usageManual');
            if (usageManualIdx !== -1) {
                helpSub.splice(usageManualIdx, 1);
            }
        }
    }
    const isEn = inWindow() ? window.systemLang === 'en' : false;
    const isSwitchingSharedAccount = useMemo(() => {
        const currentUser = systemApi.getCurrentUser();
        return !!(sharedAccount.sharedAccounts.some(item => item.email === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) ||
            (sharedAccount.isSharedAccountLogin && !sharedAccount.isSharedAccountExpired && sharedAccount.email === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)));
    }, [sharedAccount]);
    return (React.createElement("div", { className: styles.contentWrapper },
        React.createElement("div", { className: styles.contentTitle, "data-test-id": "pc-sidebar-avatar-popover-title" },
            React.createElement("div", { className: styles.avatarNameWarp },
                React.createElement("div", { className: styles.avatar },
                    React.createElement(AvatarTag, { size: 40, contactId: (_a = user.contact) === null || _a === void 0 ? void 0 : _a.contact.id, user: {
                            name: user === null || user === void 0 ? void 0 : user.nickName,
                            avatar: user === null || user === void 0 ? void 0 : user.avatar,
                            color: (_c = (_b = user === null || user === void 0 ? void 0 : user.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.color,
                            email: user === null || user === void 0 ? void 0 : user.id,
                            logcAvatar: (user === null || user === void 0 ? void 0 : user.avatar) ? user.avatar : undefined,
                        }, cameraStyle: { width: 24, height: 24 }, hasHover: !isCorpMail, onClick: checkAvatar }),
                    React.createElement("input", { ref: avatarInputRef, type: "file", accept: "image/gif, image/jpeg, image/jpg, image/png", className: styles.avatarInput, onClick: e => {
                            e.target.value = '';
                        }, onChange: avatarInputChange })),
                React.createElement("div", { className: `${styles.name} sirius-ellipsis-text` },
                    React.createElement("span", null, ((_d = user === null || user === void 0 ? void 0 : user.contact) === null || _d === void 0 ? void 0 : _d.contact.contactName) || user.nickName || user.id || ''))),
            React.createElement("div", { className: styles.accountName },
                React.createElement(Tooltip, { placement: "right", trigger: "hover", overlayInnerStyle: { padding: 17 }, title: (mailList === null || mailList === void 0 ? void 0 : mailList.length) > 0 ? aliasPopover : user.id },
                    React.createElement("span", { style: { maxWidth: '90%', cursor: 'pointer' }, className: "sirius-ellipsis-text" }, user.loginAccount || user.id),
                    (mailList === null || mailList === void 0 ? void 0 : mailList.length) > 0 && React.createElement(ExpandSvg, { style: { cursor: 'pointer', marginLeft: 4 } }))),
            React.createElement("div", { className: styles.company },
                React.createElement(Tooltip, { title: user.company, placement: "right", trigger: "hover" }, user.company))),
        React.createElement("div", { className: styles.contentMenu },
            React.createElement(MenuItem, { type: "account", onCLick: () => handleClick('accountSetting'), title: getIn18Text('ZHANGHAOYUANQUAN') }),
            React.createElement(MenuItem, { type: "setting", onCLick: () => handleClick('mailSetting'), title: getIn18Text('YOUXIANGSHEZHI') }),
            process.env.BUILD_ISEDM && visibleEnterpriseSetting && version !== 'WEBSITE' && (React.createElement(MenuItem, { type: "enterprisesetting", onCLick: () => {
                    toggleVisible();
                    trackApi.track('client_1_enterprise_setup', { version: 1 });
                    navigate('#enterpriseSetting');
                }, title: getTransText('QIYESHEZHI') })),
            process.env.BUILD_ISEDM && isEdmAdmin && rbacVisible && React.createElement(MenuItem, { type: "rbac", onCLick: () => handleClick('rbac'), title: getIn18Text('QUANXIANSHEZHI') }),
            process.env.BUILD_ISEDM && version !== WAIMAO_PRODUCT_VERSIONS.WEBSITE && version !== WAIMAO_PRODUCT_VERSIONS.FREE && !navigateVersion && (React.createElement(MenuItem, { type: "knowledgeCenter", onCLick: () => handleClick('knowledgeCenter'), title: getTransText('ZHISHIGUANGCHANG') })),
            process.env.BUILD_ISEDM && !!taskCenterSubItems.length && version !== WAIMAO_PRODUCT_VERSIONS.WEBSITE && (React.createElement(MenuItem, { type: "taskCenter", title: getTransText('RENWUZHONGXIN'), onCLick: () => { }, subItems: taskCenterSubItems })),
            process.env.BUILD_ISEDM || isCorpMail || isEn ? ('') : (React.createElement(MenuItem, { type: "productVersion", onCLick: () => handleClick('productVersion'), title: getIn18Text('FUWUTAOCAN'), productName: productVersionName })),
            process.env.BUILD_ISEDM ? (React.createElement(MenuItem, { onCLick: () => { }, type: "feedback", title: getIn18Text('WENTIFANKUI'), subItems: wbhelpSub })) : (React.createElement(MenuItem, { onCLick: () => { }, type: "feedback", title: getIn18Text('BANGZHUYUFANKUI'), subItems: helpSub })),
            process.env.BUILD_ISELECTRON && !isSwitchingSharedAccount ? (React.createElement(MenuItem, { type: "lockApp", onCLick: () => {
                    handleClick('lockApp');
                }, title: getIn18Text('LOCK_APP') })) : null,
            process.env.BUILD_ISEDM && process.env.BUILD_ISELECTRON && (React.createElement(MenuItem, { onCLick: () => handleClick('wmWebEntry'), type: "wmWebEntry", title: getIn18Text('WANGYEBANWAIMAOTONG') })),
            process.env.BUILD_ISEDM && !inElectron && (React.createElement(MenuItem, { onCLick: () => handleClick('wmOldWebEntry'), type: "wmOldWebEntry", title: getIn18Text('FANGWENXINBAN') })),
            process.env.BUILD_ISEDM && React.createElement(MenuItem, { onCLick: () => handleClick('wmUpdateLog'), type: "wmUpdateLog", title: getIn18Text('UpdateLog') }),
            inElectron && React.createElement(MenuItem, { type: "update", onCLick: () => checkUpgrade(), title: getIn18Text('JIANCHAGENGXIN') }),
            React.createElement(MenuItem, { type: "about", onCLick: () => handleAbout(), title: getIn18Text('GUANYU') }),
            visibleAdmin && !isCorpMail && React.createElement(MenuItem, { type: "backend", onCLick: () => handleClick('backend'), title: getIn18Text('GUANLIHOUTAI') }),
            (!inElectron || conf('stage') === 'local') && (React.createElement("div", { className: styles.contentItemWrap, onClick: handleLogout },
                React.createElement("div", { className: styles.contentItem },
                    React.createElement("span", { className: styles.icon },
                        React.createElement(ExitSvg, null)),
                    React.createElement("span", { className: styles.itemLink },
                        React.createElement("span", null, getIn18Text('TUICHUDENGLU'))))))),
        React.createElement(About, { isElectron: false, isVisible: false, toggle: handle }),
        showFeedbackModal ? React.createElement(FeedbackModal, { visible: showFeedbackModal, cancel: () => closeFeedback() }) : null,
        showAvatarEditor && curAvatar && (React.createElement(AvatarEditor, { avatar: curAvatar, contactId: contactId, contactEmail: contactEmail, showResetEntry: true, onImageError: () => {
                const midAvatar = transAvatarSize(user.avatar, 'middle');
                setCurAvatar(midAvatar);
            }, hideAvatarEditor: hideAvatarEditor })),
        React.createElement(ProductVersion, { productVisible: productVisible, cancelMed: () => {
                handleProduct(false);
            }, onUpgradeModel: onUpgradeModel }),
        React.createElement(UpgradeMeansModal, { visible: upGradeVisible, onClose: showSuccess => {
                showSuccess && setSuccessVisible(true);
                setUpGradeVisible(false);
            } }),
        React.createElement(SuccessModal, { visible: successVisible, onClose: () => {
                setSuccessVisible(false);
            } })));
};
const Avatar = ({ notifyBlocking }) => {
    var _a, _b, _c;
    const [blockingFunction, setBlockingFunction] = useState(false);
    const [user, setUser] = useState();
    const [mailList, setMailList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visibleAdmin, setVisibleAdmin] = useState(false);
    const [avatarRefreshCount, setAvatarRefreshCount] = useState(0);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (visible) {
            accountApi
                .doGetMailAliasAccountListV2({ noMain: true })
                .then(res => setMailList(res === null || res === void 0 ? void 0 : res.map(item => item === null || item === void 0 ? void 0 : item.id)))
                .catch(() => {
                setMailList([]);
            });
            accountApi.doGetAccountIsAdmin().then(res => setVisibleAdmin(res));
        }
    }, [visible]);
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('loginBlock', {
            func: ev => {
                setBlockingFunction(ev.eventData);
                notifyBlocking && notifyBlocking(ev.eventData);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('loginBlock', eid);
        };
    });
    const toggleVisible = () => {
        setVisible(false);
    };
    const showBlockingMsg = () => {
        SiriusMessage.warn({ content: getIn18Text('QINGQIEHUANZHIQI') }).then();
    };
    const handleSetting = (config) => {
        if (!config.from) {
            if (config.type === 'block') {
                setBlockingFunction(true);
                if (notifyBlocking) {
                    notifyBlocking(true);
                }
            }
            else if (config.type === 'unblock') {
                setBlockingFunction(false);
                if (notifyBlocking) {
                    notifyBlocking(false);
                }
            }
        }
        else if (config.from === 'menu' || config.from === 'msg' || config.from === 'avatar') {
            if (!blockingFunction) {
                if (config.type === 'account') {
                    trackApi.track('pcMineCenter_click_accountManagement_mineCenterCard');
                }
                else if (config.type === 'mail') {
                    trackApi.track('pcMineCenter_click_mailSet_mineCenterCard');
                }
            }
            else {
                showBlockingMsg();
            }
        }
        setVisible(false);
    };
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('settingShow', {
            func: (ev) => {
                if (ev && ev.eventData && ev.eventData.action === 'show' && ev.eventData.type) {
                    handleSetting({ type: ev.eventData.type, from: 'msg' });
                }
                else if (ev && ev.eventData && ev.eventData.action === 'hide') {
                }
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('settingShow', eid);
        };
    }, []);
    useEffect(() => {
        setUser(systemApi.getCurrentUser());
    }, [lodashGet(systemApi.getCurrentUser(), 'nickName', ''), lodashGet(systemApi.getCurrentUser(), 'avatar', '')]);
    useMsgRenderCallback('updateUserInfo', () => {
        setUser(systemApi.getCurrentUser());
    });
    useMsgRenderCallback('storeUserChangeEvent', () => {
        setUser(systemApi.getCurrentUser());
    });
    useEffect(() => {
        if (visible) {
            if (!process.env.BUILD_ISLINGXI) {
                dispatch(getMyRolesAsync());
                dispatch(getMenuSettingsAsync());
            }
            setAvatarRefreshCount(count => count + 1);
        }
    }, [visible]);
    const userAvatarEl = (React.createElement("div", { className: classnames([styles.avatarWrapper, process.env.BUILD_ISEDM ? styles.avatarWrapperEdm : '']), onClick: () => {
            blockingFunction && showBlockingMsg();
        } },
        React.createElement(AvatarTag, { size: process.env.BUILD_ISEDM ? 36 : 40, refreshCount: avatarRefreshCount, contactId: (_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id, user: {
                name: user === null || user === void 0 ? void 0 : user.nickName,
                avatar: user === null || user === void 0 ? void 0 : user.avatar,
                email: user === null || user === void 0 ? void 0 : user.id,
                color: (_c = (_b = user === null || user === void 0 ? void 0 : user.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.color,
                logcAvatar: (user === null || user === void 0 ? void 0 : user.avatar) ? user === null || user === void 0 ? void 0 : user.avatar : undefined,
            }, testId: "pc-sidebar-avatar" })));
    return (React.createElement("div", null, blockingFunction ? (userAvatarEl) : (React.createElement(Popover, { overlayStyle: {
            zIndex: 1000,
        }, overlayClassName: styles.avatarPopoverWrap, className: "sirius-no-drag", visible: visible, trigger: "click", onVisibleChange: () => {
            setVisible(!visible);
            trackApi.track('pcMineCenter_click_headPortrait_leftNavigationBar');
        }, content: user ? React.createElement(AvatarContent, { mailList: mailList, visibleAdmin: visibleAdmin, toggleVisible: toggleVisible, user: user }) : null, placement: "rightTop" }, userAvatarEl))));
};
export default Avatar;
